const BASE_URL = 'https://languable.onrender.com'

export const API_URL = (slug) => `${BASE_URL}/${slug}`